import { Component, computed, input } from '@angular/core';
import { OutageType } from '../../models/power-outage.model';

@Component({
  selector: 'app-dot',
  template: '',
  styles: `
    :host {
      display: inline-block;
      border-radius: 50%;
      height: 16px;
      aspect-ratio: 1;
    }

    :host(.planned) {
      border-radius: 0;
    }
  `,
  host: {
    '[class.planned]': 'isPlanned()',
    '[class.background--signal-warning]': 'isPlanned()',
    '[class.background--signal-danger]': '!isPlanned()',
    'aria-hidden': 'true',
  },
})
export class DotComponent {
  readonly outageType = input.required<OutageType>();

  protected readonly isPlanned = computed(() => this.outageType() === 'Planned');
}
